import CashGuardDirect from './cashguarddirect'
import CashGuardRest from './cashguardrest'
import type { CashMachineOptions, ICashMachine } from './types'

class CashGuard implements ICashMachine {
  private machine!: typeof CashGuardDirect | typeof CashGuardRest

  init(config: CashMachineOptions) {
    if (config.type === 'ip') {
      this.machine = CashGuardRest
    } else {
      this.machine = CashGuardDirect
    }
    this.machine.init(config)
  }

  charge(amount: number) {
    return this.machine.charge(amount)
  }

  payIn(amount: number) {
    return this.machine.payIn(amount)
  }

  payOut(amount: number) {
    return this.machine.payOut(amount)
  }

  cancel() {
    return this.machine.cancel()
  }

  close() {
    return this.machine.close()
  }
}

export default new CashGuard()
